import React, { FC, useState } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useSort } from "@/components/atoms";
import SearchList from "@/components/templates/SearchList/SearchList";
import { Document, DocumentsPageParams, SearchDocumentsSortProperty, SortOrder } from "@/shared/domain";

import DocumentTable from "../components/DocumentTable/DocumentTable";
import useDocumentQueries from "../useDocumentQueries";

const DocumentsSearchPage: FC = () => {
    const { filter } = useParams<DocumentsPageParams>();
    const { t } = useTranslation();

    const [textSearch, setTextSearch] = useState("");
    const [orderBy, orderByActions] = useSort<SearchDocumentsSortProperty>({
        sort: { property: "date", order: SortOrder.Descending },
    });
    const { tableMode, useDocumentsSearchQuery } = useDocumentQueries();
    const { result, isFetching } = useDocumentsSearchQuery({
        textSearch,
        sortProperty: orderByActions.getManualSortProperty(),
        filter,
    });

    const renderTable = (items: Document[]) => (
        <DocumentTable documents={items} orderBy={orderBy} handleSort={orderByActions.updateSort} />
    );

    return (
        <SearchList
            items={result}
            tableMode={tableMode}
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            renderTable={renderTable}
            isFetching={isFetching}
            placeholder={t("Common.Search")}
            emptyListMessage={t("Documents.Empty")}
            pageTitle={t("PageTitles.MyDocuments")}
        />
    );
};

export default DocumentsSearchPage;
